import { computed, type ReadableAtom } from 'nanostores';
import { settingsService } from '~/lib/services/settings-service';
import type { Theme, ThemeOption } from '~/types/theme';

// FIXME: this is legacy and can be removed after a while
export const kTheme = 'bolt_theme';

export const DEFAULT_THEME = 'dark';

const _themeStore = computed(settingsService.settingsStore, (settings) => {
  let theme = settings.appearance.theme;

  if (theme === 'system') {
    theme = prefersDark() ? 'dark' : 'light';
  }

  return theme;
});

export const themeOptionStore = computed(settingsService.settingsStore, (settings) => settings.appearance.theme);

// we force the type to be read-only so that the theme can only be updated through the helpers at the bottom
export const themeStore = _themeStore as ReadableAtom<Theme>;

export function themeIsDark() {
  return themeStore.get() === 'dark';
}

export function toggleTheme() {
  const currentTheme = _themeStore.get();
  const newTheme = currentTheme === 'dark' ? 'light' : 'dark';

  setTheme(newTheme);
}

export function setTheme(theme: ThemeOption) {
  preventTransitions();

  localStorage.setItem(kTheme, theme);

  settingsService.set('appearance', 'theme', theme);
}

function prefersDark() {
  return window.matchMedia('(prefers-color-scheme: dark)').matches;
}

if (!import.meta.env.SSR) {
  window.matchMedia('(prefers-color-scheme: dark)').addEventListener('change', () => {
    preventTransitions();
  });
}

// set all elements to transition none while changing theme
function preventTransitions() {
  const css = `* { transition: none !important; }`;

  const style = document.createElement('style');
  style.innerHTML = css;
  document.head.appendChild(style);

  requestAnimationFrame(() => {
    style.remove();
  });
}

if (import.meta.env.DEV) {
  Object.assign(globalThis, { toggleTheme });
}
